import { render, staticRenderFns } from "./SiteProportion.vue?vue&type=template&id=65fc59ae&scoped=true"
import script from "./SiteProportion.vue?vue&type=script&lang=js"
export * from "./SiteProportion.vue?vue&type=script&lang=js"
import style0 from "./SiteProportion.vue?vue&type=style&index=0&id=65fc59ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fc59ae",
  null
  
)

export default component.exports